import { RelationshipIndividualDto } from "@models/individuals/relationship-individual-dto";
import { Contact } from "@models/common/contact";
import { Address } from "../../../../../models/address/address";
import { RelationshipType } from "@models/relationships/relationship-type.enum";
import { IndividualData } from "@models/individuals/individual-data";
import { EntityType } from "@models/common/entity-type.enum";
import { Guid } from "../../../../../shared/utils/guid.helper";

export class IndividualRelationshipGroupModel {
  relationshipsIds: string[];
  relationshipsDtos: RelationshipIndividualDto[];
  contactIds: string[];
  contacts: Contact[];
  address: Address;
  start: Date | null;
  end: Date | null;
  dob: Date | null;
  types: RelationshipType[];
  individualDataOverride?: IndividualData;
  entityId: string;
  entityName: string;
  entityNumber: string;
  relatedToEntityType: EntityType | null;
  name: string;
  birthCity: string;
  birthCountry: string;

  constructor(data: Partial<IndividualRelationshipGroupModel> = {}) {
    this.relationshipsIds = data.relationshipsIds ?? [];
    this.relationshipsDtos = data.relationshipsDtos ?? [];
    this.contactIds = data.contactIds ?? [];
    this.contacts = data.contacts ?? [];
    this.address = data.address ?? new Address();
    this.start = data.start ?? null;
    this.end = data.end ?? null;
    this.dob = data.dob ?? null;
    this.types = data.types ?? [];
    this.entityId = data.entityId ?? '';
    this.entityName = data.entityName ?? '';
    this.entityNumber = data.entityNumber ?? '';
    this.relatedToEntityType = data.relatedToEntityType ?? null;
    this.name = data.name ?? '';
    this.birthCity = data.birthCity ?? '';
    this.birthCountry = data.birthCountry ?? '';
  }

  isRelatedRelationship(relationship: RelationshipIndividualDto): boolean {
    return Guid.isValidGuid(relationship.relationshipId)
      && !!relationship.individualDataOverride
      && !this.types.includes(relationship.type)
      && this.name == relationship.individualDataOverride?.fullName
      && relationship.individualDataOverride?.address
      && this.address.isEqual(relationship.individualDataOverride?.address)
      && this.start?.toString() == relationship.start?.toString()
      && this.end?.toString() == relationship.end?.toString()
      && this.dob?.toString() == relationship.individualDataOverride.dob?.toString()
      && this.birthCity == relationship.individualDataOverride.birthCity
      && this.birthCountry == relationship.individualDataOverride.birthCountry;
  }

  addRelationship(relationship: RelationshipIndividualDto) {
    this.relationshipsIds.push(relationship.relationshipId);
    this.relationshipsDtos.push(relationship);
    this.types.push(relationship.type);

    if (relationship.contactId && relationship.contact) {
      this.contactIds.push(relationship.contactId);
      this.contacts.push(relationship.contact);
    }
  }

  get isResigned(): boolean {
    return this.end != undefined && new Date(this.end) < new Date();
  }

  static fromRelationshipIndividualDto(relationship: RelationshipIndividualDto): IndividualRelationshipGroupModel {
    return new IndividualRelationshipGroupModel({
      relationshipsIds: [relationship.relationshipId],
      relationshipsDtos: [relationship],
      contactIds: [relationship.contactId].filter(Boolean) as string[],
      contacts: [relationship.contact].filter(Boolean) as Contact[],
      address: relationship.individualDataOverride?.address ? new Address(relationship.individualDataOverride?.address) : new Address(),
      start: relationship.start ?? null,
      end: relationship.end ?? null,
      dob: relationship.individualDataOverride?.dob ?? null,
      types: [relationship.type],
      individualDataOverride: new IndividualData(relationship.individualDataOverride ?? {}),
      entityId: relationship.entityId ?? '',
      entityName: relationship.entityName ?? '',
      entityNumber: relationship.entityNumber ?? '',
      relatedToEntityType: relationship.relatedToEntityType ?? null,
      name: relationship.name || relationship.individualDataOverride?.fullNameLabel || '',
      birthCity: relationship.individualDataOverride?.birthCity ?? '',
      birthCountry: relationship.individualDataOverride?.birthCountry ?? '',
    });
  }
}
